<template>
  <div class="columns-select">
    <div class="columns-select__search">
      <MSearchInline
        v-model="searchQuery"
        class="m-items-picker__search-input"
        :placeholder="_getTr('search')"
        :emit-input-on-change="false"
      />
    </div>
    <div class="columns-select__select-all">
      <MCheckbox
        :value="allSelected"
        :intermediate="areSomeSelected"
        :label-text="_getTr('select_all')"
        @input="toggleAll"
      />
    </div>
    <div>
      <ColumnsSelectGroup
        v-for="group in filteredColumns"
        :key="group.id"
        :group="group"
        :is-searching="isSearching"
        :selected-items="value"
        @toggleItems="$emit('toggleItems', $event)"
      />
    </div>
  </div>
</template>

<script>

  import MSearchInline from 'components/common/MSearchInline';
  import ColumnsSelectGroup from 'components/Data/TableSettings/TableSettingsModal/ColumnsSelect/ColumnsSelectGroup';
  import MCheckbox from 'components/Inputs/Basic/MCheckbox';
  import filterSearch from 'utils/search/filterSearch';

  function filterChoicesDeep (searchQuery, choices) {
    return choices.map(item => {
      if (item.name.toLowerCase().includes(searchQuery)) {
        return item;
      }
      if (!item.children) {
        return null;
      }
      const filteredChildren = filterChoicesDeep(searchQuery, item.children);
      if (filteredChildren.length === 0) {
        return null;
      }
      return {
        ...item,
        children: filteredChildren
      };
    }).filter(i => Boolean(i));
  }

  export default {
    name: 'ColumnsSelect',
    components: {MCheckbox, ColumnsSelectGroup, MSearchInline},
    props: {
      value: {
        type: Array,
        default: Array
      },
      availableColumns: {
        type: Array,
        required: true
      }
    },
    data () {
      return {
        searchQuery: ''
      };
    },
    computed: {
      filteredSearchQuery () {
        return filterSearch(this.searchQuery);
      },
      isSearching () {
        return Boolean(this.filteredSearchQuery);
      },
      filteredColumns () {
        if (!this.filteredSearchQuery) {
          return this.availableColumns;
        }
        return filterChoicesDeep(this.filteredSearchQuery.toLowerCase(), this.availableColumns);
      },
      filteredIdsFlat () {
        return this.filteredColumns.map(g => g.children.map(i => {
          if (!i.children) {
            return i.id;
          }
          return i.children.map(c => c.id);
        })).flat(2);
      },
      filteredEnabledIdsFlat () {
        return this.filteredColumns.map(g => g.children.map(i => {
          if (!i.children) {
            return i;
          }
          return i.children;
        })).flat(2).
          filter(c => !c.disabled).
          map(c => c.id);
      },
      allSelected () {
        const selectedSet = new Set(this.value);
        return this.filteredIdsFlat.every(i => selectedSet.has(i));
      },
      areSomeSelected () {
        if (this.allSelected) {
          return false;
        }
        const selectedSet = new Set(this.value);
        return this.filteredIdsFlat.some(i => selectedSet.has(i));
      }
    },
    methods: {
      toggleAll (status) {
        this.$emit('toggleItems', {status, itemIds: this.filteredEnabledIdsFlat});
      }
    }
  };
</script>

<style>
  .columns-select {
    padding: 20px;
  }

  .columns-select__select-all {
    margin-top: 14px;
  }

</style>
